import { render } from "./PexelImages.vue?vue&type=template&id=60daabdf"
import script from "./PexelImages.vue?vue&type=script&lang=js"
export * from "./PexelImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__